import {createAction} from 'web-app/util/redux/famly-app-helpers';

import {type ActivityLink, type TrackingObject} from './types';

const domain = 'MODALS/ACTIVITIES';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (payload: {
        handleSelectActivity: (activity: ActivityLink) => void;
        trackingFunction?: ({entryPoint, library}: TrackingObject) => void;
        addButtonText?: string;
        institutionId?: string;
    }) => payload,
);

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));
